import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { CopyButton } from 'foundations-components/transitional/components/CopyButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SUPPORT_LINK_BUTTON_WIDTH = '184px';
const SUPPORT_LINK_IMAGE_HEIGHT = 72;
function InnerButtonWrapper({
  children
}) {
  return /*#__PURE__*/_jsx(Flex, {
    alignItems: "stretch",
    inlineSize: "100%",
    blockSize: "100%",
    flexDirection: "column",
    justifyContent: "center",
    children: children
  });
}
export default function SupportLinkBox({
  children,
  href,
  illustrationName,
  onClick,
  textLabel,
  copyText
}) {
  return /*#__PURE__*/_jsx(Flex, {
    alignItems: "stretch",
    marginInlineStart: "300",
    marginBlockStart: "300",
    inlineSize: SUPPORT_LINK_BUTTON_WIDTH,
    minBlockSize: "180px",
    borderStyle: "solid",
    borderWidth: "100",
    borderColor: "border-core-default",
    borderRadius: "100",
    overflow: "hidden",
    paddingInline: "400",
    children: copyText ? /*#__PURE__*/_jsx(CopyButton, {
      value: copyText,
      href: href,
      onClick: onClick,
      use: "unstyled",
      marginInline: "auto",
      children: /*#__PURE__*/_jsxs(InnerButtonWrapper, {
        children: [children || /*#__PURE__*/_jsx(Illustration, {
          height: SUPPORT_LINK_IMAGE_HEIGHT,
          name: illustrationName,
          paddingBlockStart: "200"
        }), /*#__PURE__*/_jsx(Text, {
          wordBreak: "break-all",
          typography: "heading-100",
          children: textLabel
        })]
      })
    }) : /*#__PURE__*/_jsx(Button, {
      marginInline: "auto",
      use: "unstyled",
      href: href,
      external: true,
      onClick: onClick,
      children: /*#__PURE__*/_jsxs(InnerButtonWrapper, {
        children: [children || /*#__PURE__*/_jsx(Illustration, {
          height: SUPPORT_LINK_IMAGE_HEIGHT,
          name: illustrationName,
          paddingBlockStart: "200"
        }), /*#__PURE__*/_jsx(Text, {
          wordBreak: "break-all",
          typography: "heading-100",
          children: textLabel
        })]
      })
    })
  });
}